import { LANGUAGE } from '@common/constants/global.constants'
import { CertificationCourse } from '@common/enums/certification.enums'
import {
	CompanyCountry,
	CompanyType
} from '@common/enums/company.enums'
import { Status } from '@common/enums/global.enums'
import { Route } from '@config/routes/routes.enums'
import { flatten } from 'flat'

const messages = {
	global: {
		buttons: {
			apply: 'Aplicar',
			cancel: 'Anular',
			clear: 'Borrar',
			confirm: 'Confirmar',
			create: 'Crear',
			delete: 'Eliminar',
			download: 'Descargar',
			export: 'Exportar',
			update: 'Actualizar'
		},
		enums: {
			certificationCourse: {
				[CertificationCourse.HALF_DAY_SBEX_HIGH_PRESSURE]: 'Half-day SBEx High Pressure',
				[CertificationCourse.HALF_DAY_SBEX_LOW_PRESSURE]: 'Half-day SBEx Low Pressure',
				[CertificationCourse.SBEX_HIGH_PRESSURE]: 'SBEx High Pressure',
				[CertificationCourse.SBEX_LOW_PRESSURE]: 'SBEx Low Pressure',
				[CertificationCourse.SBEX_MPI]: 'SBEx Mpi',
				[CertificationCourse.SBEX_PHASTITE]: 'SBEx Phastite'
			},
			companyCountry: {
				[CompanyCountry.AFGHANISTAN]: 'Afganistán',
				[CompanyCountry.ALBANIA]: 'Albania',
				[CompanyCountry.ALGERIA]: 'Argelia',
				[CompanyCountry.ANDORRA]: 'Andorra',
				[CompanyCountry.ANGOLA]: 'Angola',
				[CompanyCountry.ANTIGUA_AND_BARBUDA]: 'Antigua y Barbuda',
				[CompanyCountry.ARGENTINA]: 'Argentina',
				[CompanyCountry.ARMENIA]: 'Armenia',
				[CompanyCountry.AUSTRALIA]: 'Australia',
				[CompanyCountry.AUSTRIA]: 'Austria',
				[CompanyCountry.AZERBAIJAN]: 'Azerbaiyán',
				[CompanyCountry.BAHAMAS]: 'Bahamas',
				[CompanyCountry.BAHRAIN]: 'Baréin',
				[CompanyCountry.BANGLADESH]: 'Bangladés',
				[CompanyCountry.BARBADOS]: 'Barbados',
				[CompanyCountry.BELARUS]: 'Bielorrusia',
				[CompanyCountry.BELGIUM]: 'Bélgica',
				[CompanyCountry.BELIZE]: 'Belice',
				[CompanyCountry.BENIN]: 'Benín',
				[CompanyCountry.BHUTAN]: 'Bután',
				[CompanyCountry.BOLIVIA]: 'Bolivia',
				[CompanyCountry.BOSNIA_AND_HERZEGOVINA]: 'Bosnia y Herzegovina',
				[CompanyCountry.BOTSWANA]: 'Botsuana',
				[CompanyCountry.BRAZIL]: 'Brasil',
				[CompanyCountry.BRUNEI]: 'Brunéi',
				[CompanyCountry.BULGARIA]: 'Bulgaria',
				[CompanyCountry.BURKINA_FASO]: 'Burkina Faso',
				[CompanyCountry.BURUNDI]: 'Burundi',
				[CompanyCountry.CABO_VERDE]: 'Cabo Verde',
				[CompanyCountry.CAMBODIA]: 'Camboya',
				[CompanyCountry.CAMEROON]: 'Camerún',
				[CompanyCountry.CANADA]: 'Canadá',
				[CompanyCountry.CENTRAL_AFRICAN_REPUBLIC]: 'República Centroafricana',
				[CompanyCountry.CHAD]: 'Chad',
				[CompanyCountry.CHILE]: 'Chile',
				[CompanyCountry.CHINA]: 'China',
				[CompanyCountry.COLOMBIA]: 'Colombia',
				[CompanyCountry.COMOROS]: 'Comoras',
				[CompanyCountry.CONGO]: 'Congo',
				[CompanyCountry.COSTA_RICA]: 'Costa Rica',
				[CompanyCountry.CROATIA]: 'Croacia',
				[CompanyCountry.CUBA]: 'Cuba',
				[CompanyCountry.CYPRUS]: 'Chipre',
				[CompanyCountry.CZECH_REPUBLIC]: 'Chequia',
				[CompanyCountry.DEMOCRATIC_REPUBLIC_OF_THE_CONGO]: 'República Democrática del Congo',
				[CompanyCountry.DENMARK]: 'Dinamarca',
				[CompanyCountry.DJIBOUTI]: 'Yibuti',
				[CompanyCountry.DOMINICA]: 'Dominica',
				[CompanyCountry.DOMINICAN_REPUBLIC]: 'República Dominicana',
				[CompanyCountry.ECUADOR]: 'Ecuador',
				[CompanyCountry.EGYPT]: 'Egipto',
				[CompanyCountry.EL_SALVADOR]: 'El Salvador',
				[CompanyCountry.EQUATORIAL_GUINEA]: 'Guinea Ecuatorial',
				[CompanyCountry.ERITREA]: 'Eritrea',
				[CompanyCountry.ESTONIA]: 'Estonia',
				[CompanyCountry.ESWATINI]: 'Esuatini',
				[CompanyCountry.ETHIOPIA]: 'Etiopía',
				[CompanyCountry.FIJI]: 'Fiyi',
				[CompanyCountry.FINLAND]: 'Finlandia',
				[CompanyCountry.FRANCE]: 'Francia',
				[CompanyCountry.GABON]: 'Gabón',
				[CompanyCountry.GAMBIA]: 'Gambia',
				[CompanyCountry.GEORGIA]: 'Georgia',
				[CompanyCountry.GERMANY]: 'Alemania',
				[CompanyCountry.GHANA]: 'Ghana',
				[CompanyCountry.GREECE]: 'Grecia',
				[CompanyCountry.GRENADA]: 'Granada',
				[CompanyCountry.GUATEMALA]: 'Guatemala',
				[CompanyCountry.GUINEA]: 'Guinea',
				[CompanyCountry.GUINEA_BISSAU]: 'Guinea-Bisáu',
				[CompanyCountry.GUYANA]: 'Guyana',
				[CompanyCountry.HAITI]: 'Haití',
				[CompanyCountry.HONDURAS]: 'Honduras',
				[CompanyCountry.HUNGARY]: 'Hungría',
				[CompanyCountry.ICELAND]: 'Islandia',
				[CompanyCountry.INDIA]: 'India',
				[CompanyCountry.INDONESIA]: 'Indonesia',
				[CompanyCountry.IRAN]: 'Irán',
				[CompanyCountry.IRAQ]: 'Irak',
				[CompanyCountry.IRELAND]: 'Irlanda',
				[CompanyCountry.ISRAEL]: 'Israel',
				[CompanyCountry.ITALY]: 'Italia',
				[CompanyCountry.JAMAICA]: 'Jamaica',
				[CompanyCountry.JAPAN]: 'Japón',
				[CompanyCountry.JORDAN]: 'Jordania',
				[CompanyCountry.KAZAKHSTAN]: 'Kazajistán',
				[CompanyCountry.KENYA]: 'Kenia',
				[CompanyCountry.KIRIBATI]: 'Kiribati',
				[CompanyCountry.KUWAIT]: 'Kuwait',
				[CompanyCountry.KYRGYZSTAN]: 'Kirguistán',
				[CompanyCountry.LAOS]: 'Laos',
				[CompanyCountry.LATVIA]: 'Letonia',
				[CompanyCountry.LEBANON]: 'Líbano',
				[CompanyCountry.LESOTHO]: 'Lesoto',
				[CompanyCountry.LIBERIA]: 'Liberia',
				[CompanyCountry.LIBYA]: 'Libia',
				[CompanyCountry.LIECHTENSTEIN]: 'Liechtenstein',
				[CompanyCountry.LITHUANIA]: 'Lituania',
				[CompanyCountry.LUXEMBOURG]: 'Luxemburgo',
				[CompanyCountry.MADAGASCAR]: 'Madagascar',
				[CompanyCountry.MALAWI]: 'Malaui',
				[CompanyCountry.MALAYSIA]: 'Malasia',
				[CompanyCountry.MALDIVES]: 'Maldivas',
				[CompanyCountry.MALI]: 'Malí',
				[CompanyCountry.MALTA]: 'Malta',
				[CompanyCountry.MARSHALL_ISLANDS]: 'Islas Marshall',
				[CompanyCountry.MAURITANIA]: 'Mauritania',
				[CompanyCountry.MAURITIUS]: 'Mauricio',
				[CompanyCountry.MEXICO]: 'México',
				[CompanyCountry.MICRONESIA]: 'Micronesia',
				[CompanyCountry.MOLDOVA]: 'Moldavia',
				[CompanyCountry.MONACO]: 'Mónaco',
				[CompanyCountry.MONGOLIA]: 'Mongolia',
				[CompanyCountry.MONTENEGRO]: 'Montenegro',
				[CompanyCountry.MOROCCO]: 'Marruecos',
				[CompanyCountry.MOZAMBIQUE]: 'Mozambique',
				[CompanyCountry.MYANMAR]: 'Myanmar',
				[CompanyCountry.NAMIBIA]: 'Namibia',
				[CompanyCountry.NAURU]: 'Nauru',
				[CompanyCountry.NEPAL]: 'Nepal',
				[CompanyCountry.NETHERLANDS]: 'Países Bajos',
				[CompanyCountry.NEW_ZEALAND]: 'Nueva Zelanda',
				[CompanyCountry.NICARAGUA]: 'Nicaragua',
				[CompanyCountry.NIGER]: 'Níger',
				[CompanyCountry.NIGERIA]: 'Nigeria',
				[CompanyCountry.NORTH_KOREA]: 'Corea del Norte',
				[CompanyCountry.NORTH_MACEDONIA]: 'Macedonia del Norte',
				[CompanyCountry.NORWAY]: 'Noruega',
				[CompanyCountry.OMAN]: 'Omán',
				[CompanyCountry.PAKISTAN]: 'Pakistán',
				[CompanyCountry.PALAU]: 'Palaos',
				[CompanyCountry.PALESTINE]: 'Palestina',
				[CompanyCountry.PANAMA]: 'Panamá',
				[CompanyCountry.PAPUA_NEW_GUINEA]: 'Papúa Nueva Guinea',
				[CompanyCountry.PARAGUAY]: 'Paraguay',
				[CompanyCountry.PERU]: 'Perú',
				[CompanyCountry.PHILIPPINES]: 'Filipinas',
				[CompanyCountry.POLAND]: 'Polonia',
				[CompanyCountry.PORTUGAL]: 'Portugal',
				[CompanyCountry.QATAR]: 'Catar',
				[CompanyCountry.ROMANIA]: 'Rumanía',
				[CompanyCountry.RUSSIA]: 'Rusia',
				[CompanyCountry.RWANDA]: 'Ruanda',
				[CompanyCountry.SAINT_KITTS_AND_NEVIS]: 'San Cristóbal y Nieves',
				[CompanyCountry.SAINT_LUCIA]: 'Santa Lucía',
				[CompanyCountry.SAINT_VINCENT_AND_THE_GRENADINES]: 'San Vicente y las Granadinas',
				[CompanyCountry.SAMOA]: 'Samoa',
				[CompanyCountry.SAN_MARINO]: 'San Marino',
				[CompanyCountry.SAO_TOME_AND_PRINCIPE]: 'Santo Tomé y Príncipe',
				[CompanyCountry.SAUDI_ARABIA]: 'Arabia Saudí',
				[CompanyCountry.SENEGAL]: 'Senegal',
				[CompanyCountry.SERBIA]: 'Serbia',
				[CompanyCountry.SEYCHELLES]: 'Seychelles',
				[CompanyCountry.SIERRA_LEONE]: 'Sierra Leona',
				[CompanyCountry.SINGAPORE]: 'Singapur',
				[CompanyCountry.SLOVAKIA]: 'Eslovaquia',
				[CompanyCountry.SLOVENIA]: 'Eslovenia',
				[CompanyCountry.SOLOMON_ISLANDS]: 'Islas Salomón',
				[CompanyCountry.SOMALIA]: 'Somalia',
				[CompanyCountry.SOUTH_AFRICA]: 'Sudáfrica',
				[CompanyCountry.SOUTH_KOREA]: 'Corea del Sur',
				[CompanyCountry.SOUTH_SUDAN]: 'Sudán del Sur',
				[CompanyCountry.SPAIN]: 'España',
				[CompanyCountry.SRI_LANKA]: 'Sri Lanka',
				[CompanyCountry.SUDAN]: 'Sudán',
				[CompanyCountry.SURINAME]: 'Surinam',
				[CompanyCountry.SWEDEN]: 'Suecia',
				[CompanyCountry.SWITZERLAND]: 'Suiza',
				[CompanyCountry.SYRIA]: 'Siria',
				[CompanyCountry.TAIWAN]: 'Taiwán',
				[CompanyCountry.TAJIKISTAN]: 'Tayikistán',
				[CompanyCountry.TANZANIA]: 'Tanzania',
				[CompanyCountry.THAILAND]: 'Tailandia',
				[CompanyCountry.TIMOR_LESTE]: 'Timor Oriental',
				[CompanyCountry.TOGO]: 'Togo',
				[CompanyCountry.TONGA]: 'Tonga',
				[CompanyCountry.TRINIDAD_AND_TOBAGO]: 'Trinidad y Tobago',
				[CompanyCountry.TUNISIA]: 'Túnez',
				[CompanyCountry.TURKEY]: 'Turquía',
				[CompanyCountry.TURKMENISTAN]: 'Turkmenistán',
				[CompanyCountry.TUVALU]: 'Tuvalu',
				[CompanyCountry.UGANDA]: 'Uganda',
				[CompanyCountry.UKRAINE]: 'Ucrania',
				[CompanyCountry.UNITED_ARAB_EMIRATES]: 'Emiratos Árabes Unidos',
				[CompanyCountry.UNITED_KINGDOM]: 'Reino Unido',
				[CompanyCountry.UNITED_STATES_OF_AMERICA]: 'Estados Unidos de América',
				[CompanyCountry.URUGUAY]: 'Uruguay',
				[CompanyCountry.UZBEKISTAN]: 'Uzbekistán',
				[CompanyCountry.VANUATU]: 'Vanuatu',
				[CompanyCountry.VATICAN_CITY]: 'Ciudad del Vaticano',
				[CompanyCountry.VENEZUELA]: 'Venezuela',
				[CompanyCountry.VIETNAM]: 'Vietnam',
				[CompanyCountry.YEMEN]: 'Yemen',
				[CompanyCountry.ZAMBIA]: 'Zambia',
				[CompanyCountry.ZIMBABWE]: 'Zimbabue'
			},
			companyType: {
				[CompanyType.DISTRIBUTOR]: 'Distribuidor',
				[CompanyType.DIVISION]: 'División',
				[CompanyType.END_USER]: 'Usuario final',
				[CompanyType.SALES_COMPANY]: 'Sales Co'
			},
			status: {
				[Status.ACTIVE]: 'Activo',
				[Status.INACTIVE]: 'Inactivo',
				[Status.DELETED]: 'Eliminado'
			}
		},
		errorPages: {
			forbidden: {
				code: '403',
				message: 'Página prohibida',
				explanation: 'La página que buscas no es accesible.'
			},
			notFound: {
				code: '404',
				message: 'Página no encontrada',
				explanation: 'La página que buscas no existe o no está disponible por el momento.'
			},
			unauthorized: {
				code: '401',
				message: 'No autorizado',
				explanation: 'No estás autorizado a acceder a la página solicitada.'
			}
		},
		errors: {
			certificationAlreadyCreated: 'Certificación ya creada para este participante',
			emailAlreadyUsed: 'E-mail ya utilizado. Debe ser único',
			occurred: 'Se produjo un error',
			pattern: 'Formato incorrecto',
			required: 'Campo obligatorio',
			traineeHasNoEmail: 'Un formador debe tener una dirección de e-mail'
		},
		fields: {
			company: 'Empresa',
			country: 'País',
			course: 'Curso',
			email: 'E-mail',
			firstname: 'Nombre',
			lastname: 'Apellido',
			name: 'Nombre',
			status: 'Estado',
			trainer: 'Formador',
			type: 'Categoría'
		},
		lang: LANGUAGE,
		tabs: {
			[Route.DASHBOARD]: 'Panel de control SBEx',
			[Route.TRAINEES]: 'Gestión de participantes SBEx',
			[Route.ANALYTICS]: 'SBEx analytics'
		}
	},
	components: {
		certificationPopIn: {
			creation: {
				title: 'Nueva certificación',
				subtitle: 'Introduce los detalles de la formación para generar la certificación.',
				buttons: {
					confirm: {
						label: 'Crear la certificación'
					}
				},
				success: 'La certificación ha sido creada'
			},
			fields: {
				trainer: {
					placeholder: 'Seleccionar un formador',
					noData: 'Ningún formador activo'
				},
				course: {
					placeholder: 'Seleccionar un curso'
				},
				isTrainer: {
					label: 'Obtener como formador'
				},
				date: {
					label: 'Fecha de formación',
					placeholder: 'Seleccionar una fecha'
				}
			}
		}
	},
	dashboard: {
		expiringCertifications: {
			title: '<a><b>{count} {count, plural, =0 {certificación} one {certificación} other {certificaciones}} {count, plural, =0 {que expira} one {que expira} other {caducadas}} </b><c>(en 3 meses o menos)</c></a>',
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				trainer: 'Formador',
				date: 'Caduca el {date}',
				discardButton: {
					label: 'Eliminar',
					success: 'La notificación ha sido eliminada'
				},
				noData: 'Ninguna certificación caducante'
			}
		},
		trainees: {
			title: 'Gestión de los participantes',
			actions: {
				addTrainee: {
					label: 'Nuevo participante',
					title: 'Nuevo participante',
					subtitle: 'Añada un participante para poder emitirle una certificación.',
					fields: {
						email: {
							label: 'Correo electrónico (obligatorio para los formadores)'
						},
						company: {
							placeholder: 'Seleccionar una empresa'
						}
					},
					buttons: {
						create: 'Crear un participante',
						createWithCertification: 'Crear un participante y añadir una certificación'
					},
					success: 'El participante ha sido creado'
				},
				addCompany: {
					title: 'Seleccionar una empresa',
					subtitle: 'Busque la empresa del participante o añádala si no está listada.',
					filters: {
						query: {
							placeholder: 'Introduzca el nombre de una empresa.'
						}
					},
					links: {
						createCompany: '<a><b>¿La empresa no existe?</b> <c><b>Haga clic aquí para crearla</b></c></a>'
					},
					noData: 'No companies'
				},
				createCompany: {
					title: 'Nueva empresa',
					subtitle: 'Cree una nueva empresa para usarla en la creación de participantes.',
					fields: {
						type: {
							placeholder: 'Seleccionar la categoría de la empresa'
						},
						country: {
							placeholder: 'Seleccionar un país'
						},
						name: {
							placeholder: 'Nombre de la empresa'
						}
					},
					buttons: {
						confirm: {
							label: 'Crear la empresa'
						}
					},
					success: 'La empresa ha sido creada'
				}
			},
			filters: {
				company: 'Seleccionar una empresa',
				companiesNotFound: 'No se encontró ninguna empresa',
				query: 'Nombre, correo electrónico o número de certificado',
				advanced: {
					title: 'Filtros avanzados',
					subtitle: 'Filtre las certificaciones por formación y/o por rango de fechas.',
					course: {
						title: 'Formación',
						select: 'Seleccionar una formación'
					},
					startDate: 'Fecha de formación a partir del',
					endDate: 'Hasta'
				}
			},
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				actions: {
					viewUpdate: {
						label: 'Ver y actualizar'
					},
					addCertification: {
						label: 'Agregar una certificación'
					}
				},
				noData: 'Ningún participante'
			}
		},
		tooltips: {
			viewTraineeDetails: 'Utilice CTRL+clic para ver los detalles del participante en una nueva pestaña'
		}
	},
	trainee: {
		information: {
			buttons: {
				save: {
					label: 'Guardar los cambios',
					success: 'La información del participante se ha guardado'
				},
				delete: {
					title: 'Eliminar al participante',
					message: '¿Confirmar la eliminación del participante?',
					success: 'El participante ha sido eliminado'
				}
			}
		},
		certifications: {
			header: {
				title: 'Certificaciones'
			},
			actions: {
				create: {
					label: 'Nueva certificación'
				},
				update: {
					title: 'Modificar la certificación',
					subtitle: 'Verifique y modifique la información antes de generar la certificación.',
					buttons: {
						confirm: {
							label: 'Guardar los cambios'
						}
					},
					success: 'La certificación ha sido actualizada'
				},
				delete: {
					title: 'Eliminar la certificación',
					message: '¿Confirmar la eliminación de la certificación?',
					success: 'La certificación ha sido eliminada'
				}
			},
			list: {
				trainer: 'Formador',
				training: 'Formado el {date} por {trainer} / {company}',
				expiringDate: 'Expira el {date}',
				noData: 'Ninguna certificación',
				download: {
					label: 'Descargar el certificado'
				}
			}
		}
	},
	analytics: {
		title: 'Datos analíticos',
		inputs: {
			startDate: {
				label: 'Selección de la fecha de inicio'
			},
			endDate: {
				label: 'Selección de la fecha de fin'
			}
		}
	}
}

const appMessages: Record<string, string> = flatten(messages)

export default appMessages
